import React, { useState } from 'react';
import Modals from '../Modals';
//components
import Modal from '@/components/Modal';
//icons
import { IconCopy, IconDeactivate, IconPencil } from '@/constants/icons/svg';
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { CampaignStatusMapEnum } from '@/constants/campaign';
// styles
import style from '../../ActionMenu.module.scss';
const ActionText = ({ text }) => {
    return (React.createElement(Text, { variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_High_Emphasis, className: style.actionText }, text));
};
const DropdownContent = ({ campaignName, campaignId, campaignStatus, }) => {
    const [modalOpen, setModalOpen] = useState('');
    const openEditModal = () => setModalOpen('edit');
    const openDuplicateModal = () => setModalOpen('duplicate');
    const openDeactivateModal = () => setModalOpen('deactivate');
    const closeModal = () => setModalOpen('');
    const modalCallBack = (open) => {
        !open && setModalOpen('');
    };
    const getContent = () => {
        let content = (_) => React.createElement("div", null);
        switch (modalOpen) {
            case 'edit':
                content = Modals.EditModalContent;
                break;
            case 'duplicate':
                content = Modals.DuplicateModalContent;
                break;
            case 'deactivate':
                content = Modals.DeactivateModalContent;
                break;
        }
        return content;
    };
    return (React.createElement("div", { className: style.menuContent },
        React.createElement(Modal, { Content: getContent(), closeOnOutsideClick: true, open: !!modalOpen, setOpen: modalCallBack, contentProps: { closeModal, campaignName, campaignId } }),
        (campaignStatus === CampaignStatusMapEnum.ACTIVE ||
            campaignStatus === CampaignStatusMapEnum.BOOKED) && (React.createElement("div", { className: style.actionItem, onClick: openEditModal },
            React.createElement(IconPencil, { fillColor: "black" }),
            React.createElement(ActionText, { text: "Edit Campaign" }))),
        React.createElement("div", { className: style.actionItem, onClick: openDuplicateModal },
            React.createElement(IconCopy, { fillColor: "black" }),
            React.createElement(ActionText, { text: "Duplicate Campaign" })),
        campaignStatus === CampaignStatusMapEnum.ACTIVE && (React.createElement("div", { className: style.actionItem, onClick: openDeactivateModal },
            React.createElement(IconDeactivate, { fillColor: "black" }),
            React.createElement(ActionText, { text: "Deactivate Campaign" })))));
};
export default DropdownContent;
